import {languageProcessing} from '@axyseo/index.js';
const {AbstractResearcher} = languageProcessing;

// All config
import firstWordExceptions from './config/firstWordExceptions';
import {all as functionWords} from './config/functionWords';
import stopWords from './config/stopWords';
import transitionWords from './config/transitionWords';
import twoPartTransitionWords from './config/twoPartTransitionWords';
import syllables from './config/syllables.json';

// All helpers
import getClauses from './helpers/getClauses';
import getStemmer from './helpers/getStemmer';
import fleschReadingScore from './helpers/calculateFleschReadingScore';

/**
 * The researcher contains all the researches, helpers, data, and config.
 */
export default class Researcher extends AbstractResearcher {
  /**
   * Constructor
   * @param {Paper} paper The Paper object that is needed within the researches.
   * @constructor
   */
  constructor(paper) {
    super(paper);

    Object.assign(this.config, {
      language: 'en',
      passiveConstructionType: 'periphrastic',
      firstWordExceptions,
      functionWords,
      stopWords,
      transitionWords,
      twoPartTransitionWords,
      syllables
    });

    Object.assign(this.helpers, {
      getClauses,
      getStemmer,
      fleschReadingScore
    });
  }
}
